import { ISelectOption } from '@crm-framework/types';

import { IManagerModel, IManagersByTeam } from '@crm-package/dictionaries';

const NOT_ASSIGNMENT_OPERATION = -1;
const EMPTY_VALUE_ID = 0;

export const createOptionsMappers = (
  leadBusinessUnit: number = NOT_ASSIGNMENT_OPERATION,
  userId: number = EMPTY_VALUE_ID
) => {
  const optionsMapper = <T extends IManagerModel>({
    id,
    name,
    businessUnits: managerBusinessUnits,
    disabled = false,
  }: T) => {
    const needToUndisable =
      leadBusinessUnit === NOT_ASSIGNMENT_OPERATION ||
      id === EMPTY_VALUE_ID ||
      id === userId;

    return {
      label: name,
      value: id,
      disabled: needToUndisable
        ? disabled
        : !managerBusinessUnits.includes(leadBusinessUnit),
    };
  };

  const groupedOptionsMapper = ({ name, managers }: IManagersByTeam) => ({
    label: name,
    options: managers?.map(optionsMapper) ?? [],
    withoutRender: name === '',
  });

  return {
    optionsMapper,
    groupedOptionsMapper,
  };
};

export const managerOptionsSorting = (
  prevItem: ISelectOption,
  item: ISelectOption
) => {
  if (prevItem.label.toUpperCase() === 'NO TEAM') return 1;

  if (item.label.toUpperCase() === 'NO TEAM') return -1;

  const collator = new Intl.Collator();

  return prevItem.label && item.label
    ? collator.compare(prevItem.label, item.label)
    : 0;
};
